/**
 * @desc undefined
 */
import { LinkInfo } from '@eastcoal/api/nexus/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryLinkInfoParameter = {
  url?: string
}

const method = 'GET'
const url = '/nexus/link/info'

export const queryLinkInfoApi = (
  params?: QueryLinkInfoParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<LinkInfo>({
    method,
    url,
    params,
    ...config
  })
}

queryLinkInfoApi.method = method
queryLinkInfoApi.url = url
